import React from 'react';
import { Link } from 'react-router-dom';
import { Trans, t } from '@lingui/macro';
import { useDispatch, useSelector } from 'react-redux';
import { startGameAgain, selectMyPlayer } from '../../../redux/gameSlice';
import { showAlert } from '../../../redux/overlaySlice';
import i18n from '../../../i18n';
import { clearWs } from '../../../connection';

export default function GameEndOverlay(props) {
  const gameResult = props.gameResult;
  const dispatch = useDispatch();
  const myPlayer = useSelector(selectMyPlayer);
  const playAgain = () => {
    if (myPlayer.is_owner) {
      dispatch(startGameAgain());
    } else {
      dispatch(showAlert({
        canEsc: true,
        alertType: "error",
        alertTitle: i18n._(t`You can't do this!`),
        alertText: i18n._(t`Unfortunately, you are not the owner of this room, so you can't start a new game in it. This button is only here so you can bother
          your room's owner to click it. When he does, the game will go back to the lobby!`)
      }))
    }
  }

  return <div>
    <div className='font-preload-titan'>-</div>
    <div id="game-end-status" className={`${gameResult} animation-game-end`}>
      {gameResult === "victory" ? <Trans>VICTORY!</Trans> : <Trans>GAME OVER</Trans>}
    </div>
    <div id="game-end-go-home-button">
      <Link to="/" className="button-with-link">
        <button className="button" onClick={clearWs}><Trans>GO TO HOMEPAGE</Trans></button>
      </Link>
      <button className="button" onClick={playAgain}><Trans>PLAY AGAIN</Trans></button>
    </div>
  </div>
}
